/** Matches patient header action buttons (e.g. View Report). Icon-only on narrow screens via CSS. */
export const VIEWER_HEADER_ACTION_BUTTON_CLASSNAME =
  'viewer-ris-header-typography inline-flex min-h-9 cursor-pointer items-center justify-center gap-2 rounded-md border border-transparent bg-[#0891B2] px-2.5 py-1.5 text-white shadow-sm transition-colors hover:bg-[#0b7f9d] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#0891B2]/40 sm:px-3';

export const IMPORT_STUDY_ACCEPT =
  '.dcm,.DCM,.dicom,.DICOM,.zip,.ZIP,application/dicom,application/zip,application/x-zip-compressed';
